import React from "react";

const RadioButton = ({
  id,
  value,
  name,
  className,
  labelName,
  labelClassName,
  onClick,
  validation,
  checked,
  dataQuestId,
  dataAnsId,
  dataAnsLabel
}) => {
  return (
    <>
      <label htmlFor={id} className={labelClassName}>
        <input
          type="radio"
          className={className}
          name={name}
          id={id}
          data-ans-id={dataAnsId}
          data-quest-id={dataQuestId}
          data-ans-label={dataAnsLabel}
          value={value}
          onClick={onClick}
          ref={validation}
          checked={checked}
        />
        {labelName}
      </label>
    </>
  );
};
export default RadioButton;
